import * as Types from '../../constants/actionTypes';
const defaultState = {
  portalUserPaginationKeys: [],
  userList: [],
  userGroupRefKey: 0
}
export default (state = defaultState, action) => {

  switch (action.type) {

    case Types.LIST_USER:
      return {
        ...state,
        userList: action.data,
      }
    case Types.PORTAL_USER_PAGE_LAST_EVALUATED_KEY: {
      let existKeys = state.portalUserPaginationKeys

      if (action.popClear) {
        if (existKeys && existKeys.length) {
          existKeys.pop()
        }
        if (action.isPrevious && existKeys.length > 1) {
          existKeys.pop()
        }
      } else if (action.isAll) {
        existKeys = []
      }
      if (action.LastEvaluatedKey) {
        existKeys.push(action.LastEvaluatedKey)
      }
      return {
        ...state,
        portalUserPaginationKeys: existKeys
      }
    }
    case Types.DELETE_USER:
      return {
        ...state,
        userList: state.userList.filter(i => i.userId !== action.data),
      }

    case Types.USER_ERR:
      return {
        ...state,
        userErr: action.userErr,
      }

    case Types.USER_ADDED:
      return {
        ...state, userList: state.userList.concat(action.userAdded)
      }
    case Types.USER_UPDATED:
      const updateUserIndex = state.userList.findIndex(i => i.userId === action.payload.userId)
      state.userList.splice(updateUserIndex, 1, action.payload)
      return {
        ...state,
      }
    case Types.NEW_USER_ADDED:
      return {
        ...state,
        userAdded: action.userAdded
      }
    ///////////////////////////////////////////
    case Types.USER_BY_ID_INFO:
      return {
        ...state,
        userById: action.data,
      }

    case Types.USER_GROUP:
      return {

        ...state,
        userGroup: action.data,
      }

    case Types.PORTAL_USER_GROUP:
      return {
        ...state,
        portalUserGroupList: action.portalUserGroupList
      }
    case Types.USER_GROUP_REF_KEY:
      return {
        ...state,
        userGroupRefKey: action.refKey,
      }

    case Types.USER_GROUP_ERR:
      return {
        ...state,
        userGroupErr: action.err,
      }
    case Types.PORTAL_USER_GROUP_ERR:
      return {
        ...state,
        portalUserGroupErr: action.err,
      }

      case Types.UPLOAD_BULK_USERS:
      return {
        ...state,
        bulkUsersData : action.usersData
      }
      case Types.BULK_USERS_ERROR:
      return {
        ...state,
        bulkUserError : action.userError
      }
      case Types.LIST_ALL_SUPERVISOR_USER_ACCESS:
        return {
          ...state,
          allUsersSupervisorAccessData: action.allUsersSupervisorAccessData
        }
      case Types.PORTAL_USER_COUNTRIES_LIST:
        return {
          ...state,
          portalUserCountries: action.payload,
        }
    default:
      return state;
  }
};
